module.exports = __webpack_public_path__ + "static/media/boy-7.9ad57f34.svg";